<template>
  <div>
    <formTitle title="報讀科目 Subjects Applied"></formTitle>
    <p>
      申請入讀通階二或通階三
      (中四或中五)者必須修讀四個核心科目及在上述名單中修讀三個選修科，數學科延伸單元(一或二)可以選修為第四個選修科，修讀選修科組合之最終決定須視乎本校時間表是否許可。
    </p>
    <p>
      Applicants applying for MS2/MS3 (S4/S5) must take all four core subjects
      and three elective subjects from the list and Mathematics Extended Part
      (Module 1 or Module 2) could be selected as the fourth elective subject.
      Elective subject combinations offered are subject to availability.
    </p>
    <el-form
      ref="subjectsApplied"
      label-position="top"
      :model="subjectsApplied"
      label-width="80px"
    >
      <div class="subjectsApplied-box">
        <div class="plain-button-title">Core</div>
        <div class="subjectsApplied-content">
          <el-form-item>
            <el-checkbox-group v-model="subjectsApplied.core">
              <template v-for="(item, index) in checkboxGroup">
                <el-row
                  v-if="index % 2 == 0"
                  :key="index"
                  :gutter="20"
                  type="flex"
                  align=""
                >
                  <el-col
                    v-for="(v, k) in checkboxGroup.slice(index, index + 2)"
                    :key="k"
                    :span="12"
                  >
                    <el-checkbox
                      :disabled="true"
                      :label="v"
                      name="type"
                    ></el-checkbox
                  ></el-col>
                </el-row>
              </template>
            </el-checkbox-group>
          </el-form-item>
        </div>
      </div>
      <div class="subjectsApplied-box">
        <div class="plain-button-title">Electives</div>
        <p>Please choose 3 or 4 out of the following subjects:</p>
        <div class="subjectsApplied-content">
          <el-form-item>
            <!-- <el-checkbox-group v-model="subjectsApplied.eletives">
              <template v-for="(item, index) in checkboxGroupEletives">
                <el-row
                  :gutter="10"
                  type="flex"
                  v-if="index % 2 === 0"
                  :key="index"
                >
                  <el-col
                    :span="12"
                    v-for="(v, k) in checkboxGroupEletives.slice(
                      index,
                      index + 2
                    )"
                    :key="k"
                  >
                    <el-checkbox
                      :disabled="isView"
                      :label="v"
                      name="type"
                    ></el-checkbox>
                  </el-col>
                </el-row>
              </template>
            </el-checkbox-group> -->
            <el-checkbox-group
              class="electives-checkbox-group"
              v-model="subjectsApplied.eletives"
            >
              <!-- <template v-for="(item, index) in checkboxGroupElectives">
              <el-row
                :gutter="10"
                type="flex"
                v-if="index % 2 === 0"
                :key="index"
              >
                <el-col
                  :span="12"
                  v-for="(v, k) in checkboxGroupElectives.slice(
                    index,
                    index + 2
                  )"
                  :key="k"
                >
                  <el-checkbox  :label="v" name="type"></el-checkbox>
                </el-col>
              </el-row>
            </template> -->
              <el-checkbox
                v-for="(item, index) in checkboxGroupElectives"
                :key="index"
                :disabled="isView"
                :label="item"
                name="type"
              ></el-checkbox>
              <!-- <el-checkbox
                v-for="(item, index) in checkboxGroupElectives"
                :disabled="setCheckboxDisabled(item)"
                :key="index"
                :label="item"
                name="type"
              ></el-checkbox> -->
            </el-checkbox-group>
          </el-form-item>
        </div>
      </div>
      <!-- <div class="subjectsApplied-box">
        <div class="plain-button-title">Other Subjects</div>
        <p>
          Please choose at least one subject from each group, except for Group
          6.
        </p>
        <div class="subjectsApplied-content">
          <el-row type="flex" align="middle">
            <el-col :span="12"> </el-col>
            <el-col :span="6" style="text-align: center">
              Standard Level
            </el-col>
            <el-col :span="6" style="text-align: center"> Higher Level </el-col>
          </el-row>
          <div class="group-list" v-for="(items, indexs) in groupTypes" :key="indexs">
            <el-row
              type="flex"
              v-for="(item, index) in setGroup(items)"
              :key="index"
              align="middle"
              class="row-middle"
            >
              <el-col :span="12">
                <div class="group-list-title" v-if="index == 0">{{ items.label }}</div>
                {{ item.subject }}
              </el-col>
              <el-col :span="6" style="text-align: center">
                <el-checkbox
                  v-model="item.isSelectedStandardLevel"
                ></el-checkbox
              ></el-col>
              <el-col :span="6" style="text-align: center"
                ><el-checkbox
                  v-model="item.isSelectedHigherLevel"
                ></el-checkbox>
              </el-col>
            </el-row>
          </div>
        </div>
      </div> -->
      <el-form-item
        v-if="!isView && !adminEdit"
        class="from-button-group"
        label=""
        style="text-align: center"
      >
        <el-button type="success" @click="onBack"> 返回 Back </el-button>
        <el-button type="primary" @click="onSave"> 儲存 Save </el-button>
        <el-button type="primary" @click="onSaveAndSubmit">
          儲存及遞交 Save and Submit
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import formTitle from "@/components/formTitle";
export default {
  components: {
    formTitle,
  },
  props: {
    subjectsApplied: {
      type: Object,
      default: function () {},
    },
    isView: {
      type: Boolean,
      default: false,
    },
    adminEdit: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    groupOne() {
      return this.subjectsApplied.otherSubjects.filter((item) => {
        return item.groupType === 0;
      });
    },
    groupTwo() {
      return this.subjectsApplied.otherSubjects.filter((item) => {
        return item.groupType === 1;
      });
    },
    groupThree() {
      return this.subjectsApplied.otherSubjects.filter((item) => {
        return item.groupType === 2;
      });
    },
    groupFour() {
      return this.subjectsApplied.otherSubjects.filter((item) => {
        return item.groupType === 3;
      });
    },
    groupFive() {
      return this.subjectsApplied.otherSubjects.filter((item) => {
        return item.groupType === 4;
      });
    },
    groupSix() {
      return this.subjectsApplied.otherSubjects.filter((item) => {
        return item.groupType === 5;
      });
    },
  },
  data() {
    return {
      isChangeElectiveList: false,
      groupTypes: [
        {
          label: "Group1",
          value: 0,
        },
        {
          label: "Group2",
          value: 1,
        },
        {
          label: "Group3",
          value: 2,
        },
        {
          label: "Group4",
          value: 3,
        },
        {
          label: "Group5",
          value: 4,
        },
        {
          label: "Group6",
          value: 5,
        },
      ],
      checkboxGroup: [
        "English Language",
        "中國語文",
        "Mathematics Compulsory Part",
        "公民與社會發展",
      ],
      checkboxGroupElectives: [
        "Biology",
        "BAFS (Accounting)",
        "BAFS (Business Management)",
        "Chemistry",
        "Chinese History",
        "Chinese Literature",
        "Economics",
        "Geography",
        "History",
        "Information & Communication Technology",
        "Literature in English",
        "Mathematics Extended Part (Module 1)",
        "Mathematics Extended Part (Module 2)",
        "Music",
        "Physics",
        "Visual Arts",
      ],
      applicantLanguages: [
        {
          label: "英語 English",
          value: 0,
        },
        {
          label: "普通話 Putonghua",
          value: 1,
        },
        {
          label: "廣東話 Cantonese",
          value: 2,
        },
      ],
    };
  },
  created() {
    this.initial();
  },
  methods: {
    onElectivesChange() {
      this.isChangeElectiveList = false;
      let isModule1 = this.subjectsApplied.eletives.some(
        (ele) => ele === "Mathematics Extended Part (Module 1)"
      );
      let isModule2 = this.subjectsApplied.eletives.some(
        (ele) => ele === "Mathematics Extended Part (Module 2)"
      );
      if (isModule1 && isModule2 && this.subjectsApplied.eletives.length >= 4) {
        this.isChangeElectiveList = true;
      }
      if (
        (!isModule1 || !isModule2) &&
        this.subjectsApplied.eletives.length >= 3
      ) {
        this.isChangeElectiveList = true;
      }
      //  if(this.subjectsApplied.eletives.some((ele)=>ele === v[v.length-1]))
    },
    setCheckboxDisabled(v) {
      let isModule1 = this.subjectsApplied.eletives.some((ele) => ele === v);
      if (this.isChangeElectiveList) {
        if (!isModule1) {
          return true;
        }
      }
      // console.log(v)
    },
    initial() {
      this.subjectsApplied.core = this.checkboxGroup;
    },
    setGroup(items) {
      let newGroup = [];
      switch (items.value) {
        case 0:
          newGroup = this.groupOne;
          break;
        case 1:
          newGroup = this.groupTwo;
          break;
        case 2:
          newGroup = this.groupThree;
          break;
        case 3:
          newGroup = this.groupFour;
          break;
        case 4:
          newGroup = this.groupFive;
          break;
        case 5:
          newGroup = this.groupSix;
          break;
      }
      return newGroup;
    },
    setLabel(index) {
      let newLabel = "";
      switch (index) {
        case 0:
          newLabel = "第一語言 First language";
          break;
        case 1:
          newLabel = "第二語言 Second language ";
          break;
        case 2:
          newLabel = "家中主要使用語言 Main language used at home";
          break;
      }
      return newLabel;
    },
    onBack() {
      this.$emit("onSubjectsAppliedBack");
    },
    onSave() {
      this.$emit("onSubjectsAppliedSave");
    },
    onSaveAndSubmit() {
      this.$emit("onSubjectsAppliedSaveAndSubmit");
    },
  },
};
</script>

<style lang="scss" scoped>
.subjectsApplied-box {
  margin: 20px 0;
}
.subjectsApplied-content {
  padding: 2.5rem;
  //蓝色边框
  border: 1px solid #0094ff;
  border-radius: 5px;
}
.el-button--primary {
  width: auto;
}
.row-middle {
  padding: 0.625rem 0;
}
.group-list {
  padding: 0.625rem 0;
  border-bottom: 1px solid #ebeef5;
}
.group-list-title {
  margin-bottom: 0.625rem;
}
::v-deep {
  .el-checkbox-group {
    // justify-items: inherit;
    align-items: inherit !important;
  }
  .electives-checkbox-group {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row !important;
  }
  .el-checkbox {
    display: flex;
    flex-direction: row !important;
    margin-right: 0;
    margin-bottom: 20px;
    width: 50% !important;
  }
}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  .subjectsApplied-content {
    padding: 1.875rem;
  }
  .from-button-group .el-button {
    margin-bottom: 0.625rem;
  }
  .from-button-group .el-button:last-child {
    margin-left: 0;
  }
  .subjects-title {
    font-size: 0.875rem;
  }
  ::v-deep {
    .el-checkbox__label {
      white-space: pre-wrap;
      word-wrap: break-word;
      word-break: keep-all;
      word-wrap: break-word;
    }
  }
}
</style>